function subdomain(url) {
    return url.split('://')[1].split('.')[0]
}

function getAppInfo() {
    const sub = subdomain(window.location.href)
    return {
        isGuardian: sub === 'guardian' || sub === 'guardian-dev' || sub === 'bssguardian',
        isShield: sub === 'shield' || sub === 'shield-dev',
    }
}

export default getAppInfo
